import { configureStore } from '@reduxjs/toolkit'
import authSlice from '../pages/auth/authSlice'
import commonSlice from './commonSlice'
import storage from 'localforage'
import systemConfigSlice from './systemConfigSlice'
import { persistReducer,persistStore } from "redux-persist"
import { usersList } from '../features/apiSlice'

const persistConfig = {
    key: 'root', // key for the storage
    storage, // storage engine to use
};
const persistedReducer = persistReducer(persistConfig, systemConfigSlice);

export const store = configureStore({
    reducer: {
        [usersList.reducerPath]:usersList.reducer,
        auth: authSlice,
        commonData:commonSlice,
        systemConfigData:persistedReducer,
        
    },
    middleware:(getDefaultMiddleware)=>
    getDefaultMiddleware().concat(usersList.middleware)
})

export const persistor = persistStore(store);